import { HttpTypes } from "@medusajs/types"
import { Text } from "@medusajs/ui"

import CopySku from "@modules/common/components/copy-sku"

type LineItemOptionsProps = {
  variant: HttpTypes.StoreProductVariant | undefined
  sku?: string | null
  "data-testid"?: string
  "data-value"?: HttpTypes.StoreProductVariant
}

const LineItemOptions = ({
  variant,
  sku,
  "data-testid": dataTestid,
  "data-value": dataValue,
}: LineItemOptionsProps) => {
  return (
    <div className="w-full overflow-hidden">
      <Text
        data-testid={dataTestid}
        data-value={dataValue}
        className="inline-block txt-medium text-ui-fg-subtle w-full overflow-hidden text-ellipsis"
      >
        Variant: {variant?.title}
      </Text>
      <CopySku sku={sku ?? variant?.sku} data-testid="product-sku" />
    </div>
  )
}

export default LineItemOptions
